var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 29,
    viewBox: "0 0 51 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5001 22.6908C30.2884 22.6908 34.1701 19.0237 34.1701 14.5002C34.1701 9.97657 30.2884 6.30957 25.5001 6.30957C20.7118 6.30957 16.8301 9.97657 16.8301 14.5002C16.8301 19.0237 20.7118 22.6908 25.5001 22.6908Z",
    stroke: "#0091DE",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5012 23.1493C31.0895 23.1493 35.6196 19.2768 35.6196 14.4997C35.6196 9.72263 31.0895 5.8501 25.5012 5.8501C19.913 5.8501 15.3828 9.72263 15.3828 14.4997C15.3828 19.2768 19.913 23.1493 25.5012 23.1493Z",
    stroke: "#0091DE",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5004 23.6088C31.8886 23.6088 37.0672 19.5307 37.0672 14.5002C37.0672 9.46966 31.8886 5.3916 25.5004 5.3916C19.1122 5.3916 13.9336 9.46966 13.9336 14.5002C13.9336 19.5307 19.1122 23.6088 25.5004 23.6088Z",
    stroke: "#0091DE",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4996 24.0678C32.6876 24.0678 38.5148 19.7842 38.5148 14.5002C38.5148 9.21621 32.6876 4.93262 25.4996 4.93262C18.3114 4.93262 12.4844 9.21621 12.4844 14.5002C12.4844 19.7842 18.3114 24.0678 25.4996 24.0678Z",
    stroke: "#0091DE",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5004 24.5263C33.4828 24.5263 39.9538 20.0373 39.9538 14.4997C39.9538 8.96223 33.4828 4.47311 25.5004 4.47311C17.518 4.47311 11.047 8.96223 11.047 14.4997C11.047 20.0373 17.518 24.5263 25.5004 24.5263Z",
    stroke: "#0091DE",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5014 24.9854C34.2837 24.9854 41.4032 20.2908 41.4032 14.4998C41.4032 8.70871 34.2837 4.01416 25.5014 4.01416C16.7191 4.01416 9.59961 8.70871 9.59961 14.4998C9.59961 20.2908 16.7191 24.9854 25.5014 24.9854Z",
    stroke: "#0091DE",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5006 25.4342C35.0829 25.4342 42.8508 20.5387 42.8508 14.4998C42.8508 8.46092 35.0829 3.56543 25.5006 3.56543C15.9183 3.56543 8.15039 8.46092 8.15039 14.4998C8.15039 20.5387 15.9183 25.4342 25.5006 25.4342Z",
    stroke: "#0091DE",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4998 25.8932C35.8819 25.8932 44.2984 20.7922 44.2984 14.4998C44.2984 8.20746 35.8819 3.10645 25.4998 3.10645C15.1176 3.10645 6.70117 8.20746 6.70117 14.4998C6.70117 20.7922 15.1176 25.8932 25.4998 25.8932Z",
    stroke: "#0091DE",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5009 26.3523C36.683 26.3523 45.7479 21.0457 45.7479 14.4999C45.7479 7.95391 36.683 2.64746 25.5009 2.64746C14.3188 2.64746 5.25391 7.95391 5.25391 14.4999C5.25391 21.0457 14.3188 26.3523 25.5009 26.3523Z",
    stroke: "#0091DE",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5001 26.8113C37.4821 26.8113 47.1955 21.2993 47.1955 14.4999C47.1955 7.70056 37.4821 2.18848 25.5001 2.18848C13.5181 2.18848 3.80469 7.70056 3.80469 14.4999C3.80469 21.2993 13.5181 26.8113 25.5001 26.8113Z",
    stroke: "#0091DE",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4993 27.2703C38.2812 27.2703 48.6431 21.5528 48.6431 14.4999C48.6431 7.447 38.2812 1.72949 25.4993 1.72949C12.7173 1.72949 2.35547 7.447 2.35547 14.4999C2.35547 21.5528 12.7173 27.2703 25.4993 27.2703Z",
    stroke: "#0091DE",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4999 27.7293C39.0762 27.7293 50.0819 21.8064 50.0819 14.4999C50.0819 7.19355 39.0762 1.27051 25.4999 1.27051C11.9237 1.27051 0.917969 7.19355 0.917969 14.4999C0.917969 21.8064 11.9237 27.7293 25.4999 27.7293Z",
    stroke: "#0091DE",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ed4285aa79abd690401b8f04220c5ff0.svg";
export { ForwardRef as ReactComponent };